import Axios from 'axios';
import forEach from 'lodash/forEach';



var typesCms = /*#__PURE__*/Object.freeze({

});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var UsersApi = /** @class */ (function () {
    function UsersApi(api) {
        this.api = api || Axios;
    }
    UsersApi.prototype.getUsers = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get('/users', config)];
            });
        });
    };
    UsersApi.prototype.getUser = function (userId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/users/" + userId, config)];
            });
        });
    };
    UsersApi.prototype.pushSubscribe = function (userId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/users/" + userId + "/push_subsribe", body, config)];
            });
        });
    };
    UsersApi.prototype.pushUnsubscribe = function (userId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/users/" + userId + "/push_unsubscribe", body, config)];
            });
        });
    };
    UsersApi.prototype.pushSettings = function (userId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.put("/users/" + userId + "/push_settings", body, config)];
            });
        });
    };
    UsersApi.prototype.putUser = function (userId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.put("/users/" + userId, data, config)];
            });
        });
    };
    UsersApi.prototype.deleteUser = function (userId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.delete("/users/" + userId, config)];
            });
        });
    };
    UsersApi.prototype.PostUserChangeEmail = function (userId, employeeId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("users/" + userId + "/employees/" + employeeId + "/change_email_without_confirm", data, config)];
            });
        });
    };
    UsersApi.prototype.deleteEmployeeUserAccess = function (userId, employeeId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.delete("/users/" + userId + "/user_accesses/employees/" + employeeId, config)];
            });
        });
    };
    UsersApi.prototype.patchUser = function (userId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.patch("/users/" + userId, data, config)];
            });
        });
    };
    UsersApi.prototype.getUserAccesses = function (userId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/users/" + userId + "/user_accesses", config)];
            });
        });
    };
    UsersApi.prototype.getUserAccess = function (userId, userAccessId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/users/" + userId + "/user_accesses/" + userAccessId, config)];
            });
        });
    };
    UsersApi.prototype.putUserAccess = function (userId, userAccessId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.put("/users/" + userId + "/user_accesses/" + userAccessId, data, config)];
            });
        });
    };
    UsersApi.prototype.deleteUserAccess = function (userId, userAccessId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.delete("/users/" + userId + "/user_accesses/" + userAccessId, config)];
            });
        });
    };
    UsersApi.prototype.patchUserAccess = function (userId, userAccessId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.patch("/users/" + userId + "/user_accesses/" + userAccessId, data, config)];
            });
        });
    };
    UsersApi.prototype.postUserChangePassword = function (userId, data, config) {
        return this.api.post("/users/" + userId + "/change_password", data, config);
    };
    UsersApi.prototype.validatePassword = function (userId, data, config) {
        return this.api.post("/users/" + userId + "/validate_password", data, config);
    };
    UsersApi.prototype.validatePasswordWithToken = function (data, config) {
        return this.api.post("/users/validate_password", data, config);
    };
    UsersApi.prototype.getNotices = function (userId, page, per_page, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/users/" + userId + "/notices?sort=published_at&desc=published_at&page=" + page + "&per_page=" + per_page, config)];
            });
        });
    };
    UsersApi.prototype.getMessages = function (userId, page, per_page, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/users/" + userId + "/messages?sort=published_at&desc=published_at&page=" + page + "&per_page=" + per_page, config)];
            });
        });
    };
    return UsersApi;
}());

// POST/clients/check
var ClientsApi = /** @class */ (function () {
    function ClientsApi(api) {
        this.api = api || Axios;
    }
    ClientsApi.prototype.getClients = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get('/clients', config)];
            });
        });
    };
    ClientsApi.prototype.getClient = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId, config)];
            });
        });
    };
    ClientsApi.prototype.getEmployees = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/employees", config)];
            });
        });
    };
    ClientsApi.prototype.postEmployees = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/clients/" + clientId + "/employees", body, config)];
            });
        });
    };
    ClientsApi.prototype.getEmployee = function (clientId, employeeId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/employees/" + employeeId, config)];
            });
        });
    };
    // exports
    ClientsApi.prototype.getClientDepartmentsExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/departments/export", config)];
            });
        });
    };
    ClientsApi.prototype.postClientDepartmentsExport = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/clients/" + clientId + "/departments/export", body, config)];
            });
        });
    };
    ClientsApi.prototype.getClientBranchesExport = function (clientId, branchId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/export", config)];
            });
        });
    };
    ClientsApi.prototype.postClientBranchesExport = function (clientId, branchId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/export", body, config)];
            });
        });
    };
    ClientsApi.prototype.getClientEmployeesExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/employees/export", config)];
            });
        });
    };
    ClientsApi.prototype.postClientEmployeesExport = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/clients/" + clientId + "/employees/export", body, config)];
            });
        });
    };
    ClientsApi.prototype.getClientCardsExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/cards/export", config)];
            });
        });
    };
    ClientsApi.prototype.postClientCardsExport = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/clients/" + clientId + "/cards/export", body, config)];
            });
        });
    };
    ClientsApi.prototype.getClientArchiveOrderExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/archives_order/export", config)];
            });
        });
    };
    ClientsApi.prototype.getClientDocumentsExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/clients/" + clientId + "/documents/export", config)];
            });
        });
    };
    ClientsApi.prototype.patchEmployee = function (clientId, employeeId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.patch("/clients/" + clientId + "/employees/" + employeeId, data, config)];
            });
        });
    };
    // TODO: data should be of type Partial<Employee>, but api is not ready for now
    ClientsApi.prototype.putEmployee = function (clientId, employeeId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.put("/clients/" + clientId + "/employees/" + employeeId, data, config)];
            });
        });
    };
    ClientsApi.prototype.getEmployeeNotifications = function (clientId, employeeId, config) {
        return this.api.get("/clients/" + clientId + "/employees/" + employeeId + "/notifications", config);
    };
    ClientsApi.prototype.putEmployeeNotification = function (clientId, employeeId, notificationId, data, config) {
        return this.api.put("/clients/" + clientId + "/employees/" + employeeId + "/notifications/" + notificationId, data, config);
    };
    ClientsApi.prototype.postClientEmployeeNotifications = function (clientId, employeeId, data, config) {
        return this.api.post("/clients/" + clientId + "/employees/" + employeeId + "/notifications", data, config);
    };
    ClientsApi.prototype.getBranches = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/branches", config);
    };
    ClientsApi.prototype.getBranch = function (clientId, branchId, config) {
        return this.api.get("/clients/" + clientId + "/branches/" + branchId, config);
    };
    ClientsApi.prototype.getDeliveryAddresses = function (clientId, branchId, config) {
        return this.api.get("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses", config);
    };
    ClientsApi.prototype.postDeliveryAddresses = function (clientId, branchId, body, config) {
        return this.api.post("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses", body, config);
    };
    ClientsApi.prototype.getDeliveryAddress = function (clientId, branchId, deliverAddressId, config) {
        return this.api.get("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/" + deliverAddressId, config);
    };
    ClientsApi.prototype.deleteDeliveryAddress = function (clientId, branchId, deliveryAddressId, config) {
        return this.api.delete("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/" + deliveryAddressId, config);
    };
    ClientsApi.prototype.putDeliveryAddress = function (clientId, branchId, deliveryAddressId, body, config) {
        return this.api.put("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/" + deliveryAddressId, body, config);
    };
    ClientsApi.prototype.patchDeliveryAddress = function (clientId, branchId, deliveryAddressId, body, config) {
        return this.api.patch("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/" + deliveryAddressId, body, config);
    };
    ClientsApi.prototype.getDeliveryAddressesTowns = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/delivery_addresses/towns", config);
    };
    ClientsApi.prototype.postImportFromTemplateClientDeliveryAddresses = function (clientId, branchId, body, config) {
        return this.api.post("/clients/" + clientId + "/branches/" + branchId + "/delivery_addresses/import", body, config);
    };
    ClientsApi.prototype.getDepartments = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/departments", config);
    };
    ClientsApi.prototype.getDepartment = function (clientId, departmentId, config) {
        return this.api.get("/clients/" + clientId + "/departments/" + departmentId, config);
    };
    ClientsApi.prototype.putDepartment = function (clientId, departmentId, body, config) {
        return this.api.put("/clients/" + clientId + "/departments/" + departmentId, body, config);
    };
    ClientsApi.prototype.patchDepartment = function (clientId, departmentId, body, config) {
        return this.api.patch("/clients/" + clientId + "/departments/" + departmentId, body, config);
    };
    ClientsApi.prototype.deleteDepartment = function (clientId, departmentId, config) {
        return this.api.delete("/clients/" + clientId + "/departments/" + departmentId, config);
    };
    ClientsApi.prototype.postDepartmentsImport = function (clientId, data, config) {
        return this.api.post("/clients/" + clientId + "/departments/import", data, config);
    };
    ClientsApi.prototype.postClientEmployeeBulk = function (clientId, data, config) {
        return this.api.post("/clients/" + clientId + "/employees/bulk", data, config);
    };
    ClientsApi.prototype.postClientRegistration = function (data, config) {
        return this.api.post('/clients/registration', data, config);
    };
    ClientsApi.prototype.getCards = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/cards", config);
    };
    ClientsApi.prototype.postCards = function (clientId, body, config) {
        return this.api.post("/clients/" + clientId + "/cards", body, config);
    };
    ClientsApi.prototype.getUsers = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/users", config);
    };
    ClientsApi.prototype.putUser = function (clientId, userId, data, config) {
        return this.api.put("/clients/" + clientId + "/users/" + userId, data, config);
    };
    ClientsApi.prototype.deleteUser = function (clientId, userId, config) {
        return this.api.delete("/clients/" + clientId + "/users/" + userId, config);
    };
    ClientsApi.prototype.getNotifications = function (clientId, config) {
        // TODO: return type
        return this.api.get("/clients/" + clientId + "/notifications", config);
    };
    // TODO: types
    ClientsApi.prototype.postNotifications = function (clientId, body, config) {
        return this.api.post("/clients/" + clientId + "/notifications", body, config);
    };
    ClientsApi.prototype.patchClient = function (clientId, data, config) {
        return this.api.patch("/clients/" + clientId, data, config);
    };
    ClientsApi.prototype.getProducts = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/products", config);
    };
    ClientsApi.prototype.postProduct = function (clientId, productId, data, config) {
        return this.api.post("/clients/" + clientId + "/products/" + productId, data, config);
    };
    ClientsApi.prototype.postEmployeesImport = function (clientId, type, data, config) {
        if (type === void 0) { type = 1; }
        return this.api.post("/clients/" + clientId + "/employees/import?type=" + type, data, config);
    };
    ClientsApi.prototype.getDashboard = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/dashboard", config);
    };
    ClientsApi.prototype.getProductDashboard = function (clientId, productId, config) {
        return this.api.get("/clients/" + clientId + "/products/" + productId + "/dashboard", config);
    };
    ClientsApi.prototype.getDocuments = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/documents", config);
    };
    ClientsApi.prototype.getDocument = function (clientId, documentId, config) {
        return this.api.get("/clients/" + clientId + "/documents/" + documentId, config);
    };
    ClientsApi.prototype.getAdministrators = function (clientId, config) {
        return this.api.get("/clients/" + clientId + "/administrators", config);
    };
    ClientsApi.prototype.getAdministrator = function (clientId, administratorId, config) {
        return this.api.get("/clients/" + clientId + "/administrators/" + administratorId, config);
    };
    ClientsApi.prototype.putAdministrator = function (clientId, administratorId, body, config) {
        return this.api.put("/clients/" + clientId + "/administrators/" + administratorId, body, config);
    };
    ClientsApi.prototype.deleteAdministrator = function (clientId, administratorId, config) {
        return this.api.delete("/clients/" + clientId + "/administrators/" + administratorId, config);
    };
    /**
     * use with searchparams `registration_identification` and `tax_identification`
     */
    ClientsApi.prototype.resendPromo = function (config) {
        return this.api.post("/clients/resend_promo", {}, config);
    };
    /**
     * use with searchparams `registration_identification` and `tax_identification`
     */
    ClientsApi.prototype.checkClient = function (config) {
        return this.api.post("/clients/check", null, config);
    };
    ClientsApi.prototype.checkClientRegistration = function (config) {
        return this.api.post("/clients/check_registration", null, config);
    };
    /**
     * use with searchparams `registration_identification` and `tax_identification` and `promo_code`
     */
    ClientsApi.prototype.verifyPromo = function (config) {
        return this.api.post("/clients/verify_promo", null, config);
    };
    return ClientsApi;
}());

var CardsApi = /** @class */ (function () {
    function CardsApi(api) {
        this.api = api || Axios;
    }
    CardsApi.prototype.getCards = function (config) {
        return this.api.get("/cards", config);
    };
    CardsApi.prototype.getCard = function (cardId, config) {
        return this.api.get("/cards/" + cardId, config);
    };
    CardsApi.prototype.getCardTransactions = function (cardId, config) {
        return this.api.get("/cards/" + cardId + "/transactions", config);
    };
    CardsApi.prototype.postCardLostPin = function (cardId, config) {
        return this.api.post("/cards/" + cardId + "/lost_pin", config);
    };
    CardsApi.prototype.postSendAmount = function (cardId, body, config) {
        return this.api.post("/cards/" + cardId + "/send_amount", body, config);
    };
    CardsApi.prototype.postCardActivate = function (cardId, config) {
        return this.api.post("/cards/" + cardId + "/activate", config);
    };
    CardsApi.prototype.postCardDeactivate = function (cardId, config) {
        return this.api.post("/cards/" + cardId + "/deactivate", config);
    };
    CardsApi.prototype.postCardBlocation = function (cardId, config) {
        return this.api.post("/cards/" + cardId + "/blocation", config);
    };
    CardsApi.prototype.postCardReplacement = function (cardId, config) {
        return this.api.post("/cards/" + cardId + "/replacement", config);
    };
    CardsApi.prototype.getCardCreditsExpiration = function (cardId, config) {
        return this.api.get("/cards/" + cardId + "/credits", config);
    };
    CardsApi.prototype.postCardsBulk = function (data, config) {
        return this.api.post("/cards/bulk", data, config);
    };
    CardsApi.prototype.getCardBalance = function (cardId, config) {
        return this.api.get("/cards/" + cardId + "/balance", config);
    };
    CardsApi.prototype.postCardCreditMemo = function (cardId, body, config) {
        return this.api.post("/cards/" + cardId + "/credit_memo_for_credit", body, config);
    };
    CardsApi.prototype.getCardsCreditSummary = function (cardId, config) {
        return this.api.get("cards/" + cardId + "/credits_summary", config);
    };
    CardsApi.prototype.postCreditNotesExport = function (clientId, body, config) {
        return this.api.post("/clients/" + clientId + "/cards/credit_notes/export", body, config);
    };
    CardsApi.prototype.postCreditNotesImport = function (clientId, body, config) {
        return this.api.post("/clients/" + clientId + "/cards/credit_notes/import", body, config);
    };
    CardsApi.prototype.getHistoryStates = function (cardId, config) {
        return this.api.get("/cards/" + cardId + "/history_states", config);
    };
    CardsApi.prototype.getHistoryRequirements = function (cardId, config) {
        return this.api.get("/cards/" + cardId + "/history_requirements", config);
    };
    /**
     * use with boolean flag `value` in searchparam
     */
    CardsApi.prototype.postAutoRenew = function (cardId, body, config) {
        return this.api.post("/cards/" + cardId + "/auto_renew", body, config);
    };
    return CardsApi;
}());

var MerchantsApi = /** @class */ (function () {
    function MerchantsApi(api) {
        this.api = api || Axios;
    }
    MerchantsApi.prototype.getMerchants = function (config) {
        return this.api.get("/merchants", config);
    };
    MerchantsApi.prototype.getMerchant = function (merchantId, config) {
        return this.api.get("/merchants/" + merchantId, config);
    };
    MerchantsApi.prototype.postMerchantsSearch = function (body, config) {
        return this.api.post('/merchants/search', body, config);
    };
    MerchantsApi.prototype.postMerchantsSearchClustering = function (body, config) {
        return this.api.post('/merchants/search_clustering', body, config);
    };
    return MerchantsApi;
}());

var MessagesApi = /** @class */ (function () {
    function MessagesApi(api) {
        this.api = api || Axios;
    }
    MessagesApi.prototype.getMessage = function (messageId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/messages/" + messageId, config)];
            });
        });
    };
    MessagesApi.prototype.getMessagesAcknowledgement = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/messages/acknowledgment", config)];
            });
        });
    };
    MessagesApi.prototype.postMessageAcknowledgement = function (messageId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/messages/" + messageId + "/acknowledgment", config)];
            });
        });
    };
    return MessagesApi;
}());

var ProductsApi = /** @class */ (function () {
    function ProductsApi(api) {
        this.api = api || Axios;
    }
    ProductsApi.prototype.getProducts = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/products", config)];
            });
        });
    };
    ProductsApi.prototype.getProduct = function (productId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/products/" + productId, config)];
            });
        });
    };
    return ProductsApi;
}());

var TransactionsApi = /** @class */ (function () {
    function TransactionsApi(api) {
        this.api = api || Axios;
    }
    TransactionsApi.prototype.getTansactions = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/transactions", config)];
            });
        });
    };
    TransactionsApi.prototype.getTansaction = function (transactionId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/transactions/" + transactionId, config)];
            });
        });
    };
    return TransactionsApi;
}());

var AuthApi = /** @class */ (function () {
    function AuthApi(api) {
        this.api = api || Axios;
    }
    AuthApi.prototype.postToken = function (body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/auth/token", body, config)];
            });
        });
    };
    AuthApi.prototype.postForgotPassword = function (body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/auth/forgot_password", body, config)];
            });
        });
    };
    AuthApi.prototype.postResetPassword = function (body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/auth/reset_password", body, config)];
            });
        });
    };
    AuthApi.prototype.postLogout = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/auth/logout", config)];
            });
        });
    };
    return AuthApi;
}());

var EmployeesApi = /** @class */ (function () {
    function EmployeesApi(api) {
        this.api = api || Axios;
    }
    EmployeesApi.prototype.getEmployee = function (employeeId, config) {
        return this.api.get("/employees/" + employeeId, config);
    };
    EmployeesApi.prototype.getEmployeeCards = function (employeeId, config) {
        return this.api.get("/employees/" + employeeId + "/cards", config);
    };
    //  FIXME: not impl yet
    EmployeesApi.prototype.getEmployeeCardsHistory = function (employeeId, config) {
        return this.api.get("/employees/" + employeeId + "/cards/history", config);
    };
    EmployeesApi.prototype.postEmployeesFind = function (config) {
        return this.api.post('/employees/find', config);
    };
    EmployeesApi.prototype.postEmployeesImport = function (clientId, body, config) {
        return this.api.post("/clients/" + clientId + "/employees/import", body, config);
    };
    EmployeesApi.prototype.getGamification = function (employeeId, config) {
        return this.api.get("/gamification/hash/" + employeeId.toUpperCase(), config);
    };
    return EmployeesApi;
}());

var CodeListsApi = /** @class */ (function () {
    function CodeListsApi(api) {
        this.api = api || Axios;
    }
    CodeListsApi.prototype.getMerchantTypes = function (config) {
        return this.api.get("/merchant_types", config);
    };
    CodeListsApi.prototype.getNotificationTypes = function (config) {
        return this.api.get("/notification_types", config);
    };
    CodeListsApi.prototype.getTransactionTypes = function (config) {
        return this.api.get("/transaction_types", config);
    };
    CodeListsApi.prototype.getDocumentTypes = function (config) {
        return this.api.get("/document_types", config);
    };
    CodeListsApi.prototype.getCountries = function (config) {
        return this.api.get("/countries", config);
    };
    CodeListsApi.prototype.getCountry = function (countryId, config) {
        return this.api.get("/countries/" + countryId, config);
    };
    CodeListsApi.prototype.getDocumentCategoryTypes = function (config) {
        return this.api.get("/document_category_types", config);
    };
    CodeListsApi.prototype.getDocumentContractTypes = function (config) {
        return this.api.get("/document_contract_types", config);
    };
    CodeListsApi.prototype.getDeliveryTypes = function (config) {
        return this.api.get("/delivery_types", config);
    };
    return CodeListsApi;
}());

var DeliveryAddressesApi = /** @class */ (function () {
    function DeliveryAddressesApi(api) {
        this.api = api || Axios;
    }
    DeliveryAddressesApi.prototype.postDeliveryAddressAccess = function (deliveryAddressId, body, config) {
        return this.api.post("/delivery_addresses/" + deliveryAddressId + "/acces", body, config);
    };
    return DeliveryAddressesApi;
}());

var CountriesApi = /** @class */ (function () {
    function CountriesApi(api) {
        this.api = api || Axios;
    }
    CountriesApi.prototype.getCountries = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/countries", config)];
            });
        });
    };
    return CountriesApi;
}());

var ImagesApi = /** @class */ (function () {
    function ImagesApi(api) {
        this.api = api || Axios;
    }
    ImagesApi.prototype.getImage = function (imageId, config) {
        return this.api.get("/images/" + imageId, config);
    };
    ImagesApi.prototype.putImage = function (imageId, data, config) {
        return this.api.put("/images/" + imageId, data, config);
    };
    return ImagesApi;
}());

var OrdersApi = /** @class */ (function () {
    function OrdersApi(api) {
        this.api = api || Axios;
    }
    OrdersApi.prototype.getOrders = function (config) {
        return this.api.get("/orders", config);
    };
    OrdersApi.prototype.postOrdersSave = function (body, config) {
        return this.api.post("/orders/save", body, config);
    };
    OrdersApi.prototype.postOrdersInit = function (config) {
        return this.api.post("/orders/init", undefined, config);
    };
    OrdersApi.prototype.getOrder = function (orderId, config) {
        return this.api.get("/orders/" + orderId, config);
    };
    OrdersApi.prototype.getOrderInProgress = function (clientId, config) {
        return this.api.get("clients/" + clientId + "/orders/order_in_progress", config);
    };
    OrdersApi.prototype.deleteOrder = function (orderId, config) {
        return this.api.delete("/orders/" + orderId, config);
    };
    OrdersApi.prototype.getOrderStates = function (config) {
        return this.api.get("/order_states", config);
    };
    OrdersApi.prototype.getOrderProduct = function (orderId, config) {
        return this.api.get("/orders/" + orderId + "/get_order_product", config);
    };
    OrdersApi.prototype.deleteProductFromOrder = function (orderProductId, config) {
        return this.api.delete("/order_products/" + orderProductId, config);
    };
    OrdersApi.prototype.getOrderPaymantTypes = function (orderId, config) {
        return this.api.get("/orders/" + orderId + "/payment_types", config);
    };
    OrdersApi.prototype.getOrderCreditActivationTypes = function (orderId, config) {
        return this.api.get("/orders/" + orderId + "/credit_activation_types", config);
    };
    OrdersApi.prototype.postOrderConfirm = function (orderId, body, config) {
        return this.api.post("/orders/" + orderId + "/confirm", body, config);
    };
    OrdersApi.prototype.postCheckStock = function (orderId, body, config) {
        return this.api.post("/orders/" + orderId + "/check_stock", body, config);
    };
    OrdersApi.prototype.postCalculateSidebar = function (orderId, config) {
        return this.api.post("/orders/" + orderId + "/calculate_sidebar", {}, config);
    };
    OrdersApi.prototype.postCalculateOrderSummary = function (orderId, config) {
        return this.api.post("/orders/" + orderId + "/calculate_summary", {}, config);
    };
    OrdersApi.prototype.postCalculateProductSummary = function (orderId, productId, config) {
        return this.api.post("/orders/" + orderId + "/calculate_summary/" + productId, {}, config);
    };
    OrdersApi.prototype.getOrdersToRepeat = function (config) {
        return this.api.get("/orders_to_repeat", config);
    };
    OrdersApi.prototype.postRepeatOrder = function (orderId, config) {
        return this.api.post("/orders/" + orderId + "/repeat", null, config);
    };
    OrdersApi.prototype.getImport = function (orderId, importId, config) {
        return this.api.get("/orders/" + orderId + "/imports/" + importId, config);
    };
    /**
     * import xlsx to order
     * @param orderId
     * @param type - Type: 1 - Recharge cards; 2 - Coupon import (one denomination); 3 - Coupon import (multiple denominations); 4 - To the address of the company; 5 - To the address of the employee; 6 - More than one company address
     * @param productId
     * @param body
     */
    OrdersApi.prototype.postImport = function (orderId, type, productId, body, config) {
        return this.api.post("/orders/" + orderId + "/import", body, config || {
            params: {
                type: type,
                product_id: productId,
            },
        });
    };
    /**
     * @param clientId
     * @param type - Type: 1 - Recharge cards; 2 - Coupon import (one denomination); 3 - Coupon import (multiple denominations); 4 - To the address of the company; 5 - To the address of the employee; 6 - More than one company address
     */
    OrdersApi.prototype.getImportTemplate = function (clientId, type, config) {
        return this.api.get("/clients/" + clientId + "/orders/import_template", config || {
            responseType: 'blob',
            params: {
                type: type,
            },
        });
    };
    OrdersApi.prototype.getDeliveryAddresses = function (orderId, productId, config) {
        return this.api.get("/orders/" + orderId + "/delivery_addresses", config || {
            params: { product_id: productId },
        });
    };
    return OrdersApi;
}());

var CMSApi = /** @class */ (function () {
    function CMSApi(api) {
        this.api = api || Axios;
    }
    CMSApi.prototype.getArticleCategories = function (config) {
        return this.api.get("/article-categories", config);
    };
    CMSApi.prototype.getCategoryArticles = function (articleCategoryId, config) {
        return this.api.get("/article-categories/" + articleCategoryId + "/articles", config);
    };
    CMSApi.prototype.getArticles = function (config) {
        return this.api.get("/articles", config);
    };
    CMSApi.prototype.getArticle = function (articleId, config) {
        return this.api.get("/articles/" + articleId, config);
    };
    CMSApi.prototype.getSpecialOffers = function (config) {
        return this.api.get("/special-offers", config);
    };
    CMSApi.prototype.getSpecialOffer = function (specialOfferId, config) {
        return this.api.get("/special-offers/" + specialOfferId, config);
    };
    CMSApi.prototype.getBanners = function (config) {
        return this.api.get("/banners", config);
    };
    CMSApi.prototype.getBanner = function (bannerId, config) {
        return this.api.get("/banners/" + bannerId, config);
    };
    CMSApi.prototype.getFaqs = function (config) {
        return this.api.get("/faqs", config);
    };
    CMSApi.prototype.getFaq = function (faqId, config) {
        return this.api.get("/faqs/" + faqId, config);
    };
    CMSApi.prototype.getHints = function (config) {
        return this.api.get("/hints", config);
    };
    CMSApi.prototype.getHint = function (hintId, config) {
        return this.api.get("/hints/" + hintId, config);
    };
    CMSApi.prototype.getNotifications = function (config) {
        return this.api.get("/notifications", config);
    };
    CMSApi.prototype.getNotification = function (notificationId, config) {
        return this.api.get("/notifications/" + notificationId, config);
    };
    CMSApi.prototype.getProductFaqs = function (productId, config) {
        return this.api.get("/products/" + productId + "/faqs", config);
    };
    CMSApi.prototype.getProducts = function (config) {
        return this.api.get('/products', config);
    };
    CMSApi.prototype.postInquiries = function (body, config) {
        return this.api.post("/inquiries", body, config);
    };
    return CMSApi;
}());

var HolderAccountsApi = /** @class */ (function () {
    function HolderAccountsApi(api) {
        this.api = api || Axios;
    }
    HolderAccountsApi.prototype.getHolderAccountCreditsSummary = function (holder_account_id, config) {
        return this.api.get("/holder_accounts/" + holder_account_id + "/credits_summary", config);
    };
    HolderAccountsApi.prototype.getHolderAccountBalance = function (holder_account_id, config) {
        return this.api.get("/holder_accounts/" + holder_account_id + "/balance", config);
    };
    return HolderAccountsApi;
}());

var ShellApi = /** @class */ (function () {
    function ShellApi(api) {
        this.api = api || Axios;
    }
    ShellApi.prototype.getClientShellTransactions = function (clientId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/shell/clients/" + clientId + "/transactions", data, config)];
            });
        });
    };
    ShellApi.prototype.getClientShellTransactionsExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/shell/clients/" + clientId + "/transactions/export", config)];
            });
        });
    };
    ShellApi.prototype.postClientShellTransactionsExport = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/shell/clients/" + clientId + "/transactions/export", body, config)];
            });
        });
    };
    ShellApi.prototype.getClientShellCards = function (clientId, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/shell/clients/" + clientId + "/cards", data, config)];
            });
        });
    };
    ShellApi.prototype.getClientShellCardsExport = function (clientId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/shell/clients/" + clientId + "/cards/export", config)];
            });
        });
    };
    ShellApi.prototype.postClientShellCardsExport = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/shell/clients/" + clientId + "/cards/export", body, config)];
            });
        });
    };
    ShellApi.prototype.postCardsBulk = function (clientId, body, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/shell/clients/" + clientId + "/cards/bulk", body, config)];
            });
        });
    };
    return ShellApi;
}());

var NoticesApi = /** @class */ (function () {
    function NoticesApi(api) {
        this.api = api || Axios;
    }
    NoticesApi.prototype.getNoticesAcknowledgement = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get("/notices/acknowledgment", config)];
            });
        });
    };
    NoticesApi.prototype.postNoticesAcknowledgeAll = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/notices/acknowledgment/all", config)];
            });
        });
    };
    return NoticesApi;
}());

var WorkPositionsApi = /** @class */ (function () {
    function WorkPositionsApi(api) {
        this.api = api || Axios;
    }
    WorkPositionsApi.prototype.getWorkPositions = function (config) {
        return this.api.get("/work_positions", config);
    };
    return WorkPositionsApi;
}());

var FullWalletApi = /** @class */ (function () {
    function FullWalletApi(api) {
        this.api = api || Axios;
    }
    FullWalletApi.prototype.getCoupons = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.get('/full_wallet/coupons', config)];
            });
        });
    };
    return FullWalletApi;
}());

function getGlobalAxios() {
    return Axios;
}
function axiosParamsToSequence(params) {
    var sequence = [];
    forEach(params, function (value, key) {
        if (Array.isArray(value)) {
            var foo = value.map(function (i) { return [key, String(i)]; });
            sequence.push.apply(sequence, foo);
        }
        else {
            sequence.push([key, String(value)]);
        }
    });
    return sequence;
}
var UP_API_BASE_URL = '/api/v1';
var API_KEY = 'aab3e68b-22de-4a0d-92d0-2b32fdf661d9';
var CMS_API_BASE_URL = '/cms-api/v1';
var upAxios = getGlobalAxios().create({
    baseURL: UP_API_BASE_URL,
    headers: {
        'X-API-KEY': API_KEY,
        'X-Language': "1",
    },
    paramsSerializer: function (data) {
        var params = new URLSearchParams(axiosParamsToSequence(data)).toString();
        return params;
    },
});
var cmsAxios = getGlobalAxios().create({
    baseURL: CMS_API_BASE_URL,
});
var authApi = new AuthApi(upAxios);
var usersApi = new UsersApi(upAxios);
var clientsApi = new ClientsApi(upAxios);
var transactionsApi = new TransactionsApi(upAxios);
var employeesApi = new EmployeesApi(upAxios);
var cardsApi = new CardsApi(upAxios);
var codeListApi = new CodeListsApi(upAxios);
var countriesApi = new CountriesApi(upAxios);
var productsApi = new ProductsApi(upAxios);
var merchantsApi = new MerchantsApi(upAxios);
var codeListsApi = new CodeListsApi(upAxios);
var imagesApi = new ImagesApi(upAxios);
var ordersApi = new OrdersApi(upAxios);
var noticesApi = new NoticesApi(upAxios);
var messagesApi = new MessagesApi(upAxios);
var workPositionsApi = new WorkPositionsApi(upAxios);
var fullWalletApi = new FullWalletApi(upAxios);
var cmsApi = new CMSApi(cmsAxios);
var holderAccountsApi = new HolderAccountsApi(upAxios);
var shellApi = new ShellApi(upAxios);

export { typesCms as CMS, getGlobalAxios, axiosParamsToSequence, upAxios, cmsAxios, authApi, usersApi, clientsApi, transactionsApi, employeesApi, cardsApi, codeListApi, countriesApi, productsApi, merchantsApi, codeListsApi, imagesApi, ordersApi, noticesApi, messagesApi, workPositionsApi, fullWalletApi, cmsApi, holderAccountsApi, shellApi, UsersApi, ClientsApi, CardsApi, MerchantsApi, MessagesApi, ProductsApi, TransactionsApi, AuthApi, EmployeesApi, CodeListsApi, DeliveryAddressesApi, CountriesApi, ImagesApi, OrdersApi, CMSApi, HolderAccountsApi, ShellApi, NoticesApi, WorkPositionsApi, FullWalletApi };
